import React from "react";
import { useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import WebSocketListener from "@/components/evaluate/WebSocketListener";

interface LayoutProps {
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({ children }) => {
  const location = useLocation();
  const hideFooterRoutes = ["/evaluate"];
  const showFooter = !hideFooterRoutes.includes(location.pathname);

  return (
    <div className="flex min-h-screen flex-col">
      <WebSocketListener />
      <Header />
      <main className="flex-1">{children}</main>
      {showFooter && <Footer />}
    </div>
  );
};
